import { StyleSheet } from '@react-pdf/renderer'
// Create styles
const styles = StyleSheet.create({

    bgImage: {
        position: "absolute",
        top: 60,
        left: 90,
        display: "block",
        minWidth: '100%',
        width: "85%",
        opacity: '.1',
        zIndex: -1,
        margin: '0 auto',
    },

    body: {
        display: 'flex', 

        paddingTop: 15,
        paddingBottom: 0,
        paddingHorizontal: 35,
        position: 'relative',
        width: '100%',
        // backgroundImage: `url(${bg_src})`,
        // backgroundRepeat:'no-repeat',
        // backgroundPosition:'center center',
        // webkitBackgroundSize: 'cover',
        // mozBackgroundSize: 'cover',
        // oBackgroundSize: 'cover',
        // border: '1 solid #000',
        // backgroundSize: 'cover',
        // width: '100%',
        // height: 'auto',
    },
    page: {
        flex: 1,
        //position: 'relative',
        flexDirection: "column",
    },
    section: {
        margin: '4 10',  
    },
    author: {
        fontSize: 12,
        textAlign: 'center',
        marginBottom: 40,
    },
    title: {
        fontSize: 24,
        textAlign: 'center',
        //fontFamily: 'Oswald'
    },
    subtitle: {
        fontSize: 18,
        margin: 7,
        //fontFamily: 'Oswald'
    },
    
    
    text: {
        margin: '4 7',
        fontSize: 14,
        textAlign: 'justify',
        fontFamily: 'Times-Roman'
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 'auto',
        width: 240,
    },
    header: {
        paddingTop: 10,
        fontSize: 30,
        marginBottom: 10,
        textAlign: 'center',
        color: '#000',
    },
    footer: {
        position: 'absolute',
        bottom: 40,
        left: 0,
        right: 0,
        fontSize: 10,
        opacity: '.7',
        textAlign: 'center',
        color: '#000',
    },
})

export default styles